import { Outlet } from 'react-router-dom';

export const LocationTrackingLayout = () => {
  return <Outlet />;
};
